module.exports = __webpack_public_path__ + "static/media/championsLeague.834d2926.svg";